let inject = [
    '$scope',
    '$state',
    '$rootScope',
    'SharedService',
    'ngAuthSettings',
    'CatalogService',
    '$uibModal',
    '$timeout',
    'CartService',
    'ByFavoritesService',
    'SessionService'
];
class BoxPostByCategoryController {
   constructor($scope, $state, $rootScope, SharedService, ngAuthSettings, CatalogService, $uibModal, $timeout, CartService, ByFavoritesService, SessionService) {
      this.$state = $state;
      this.$uibModal = $uibModal;
      this.$scope = $scope;
      this.CatalogService = CatalogService;
      this.CartService = CartService;
      this.$timeout = $timeout;
      this.ngAuthSettings = ngAuthSettings;
      this.$rootScope = $rootScope;
      this.SharedService = SharedService;
      this.productsInfo = {};
      this.btnPrev = "";
      this.btnNext = "";
      this.classCarousel = "";
      this.ByFavoritesService = ByFavoritesService;
      this.SessionService = SessionService;

      this.dataCart = {};
      this.dataProducs = {};

      this.productItems = {};

   }
   
   $onInit() {
   }
   
}

BoxPostByCategoryController.$inject = inject;

export default BoxPostByCategoryController;


// WEBPACK FOOTER //
// ./www/components/catalog/category/box-post-by-category/box-post-by-category.controller.js